import { Uuid } from '@belimo-retrofit-portal/logic';
import { pipe } from 'fp-ts/function';
import * as A from 'fp-ts/ReadonlyArray';
import * as R from 'fp-ts/ReadonlyRecord';
import { createSelector } from 'reselect';
import { PdfMetadata } from 'src/modules/common/types/PdfMetadata';
import { getReportAttachments } from 'src/modules/report/selectors/getReportAttachments';
import { ReportAttachmentDocument } from 'src/modules/report/types/ReportAttachment';

export const getReportEmbeddings = createSelector([
  getReportAttachments,
], (attachments): R.ReadonlyRecord<Uuid, PdfMetadata> => pipe(
  attachments,
  A.filter((it): it is ReportAttachmentDocument => it.state === 'success' && it.type === 'document'),
  A.map((it) => [it.file.id, it.meta] as const),
  R.fromEntries,
));
